export type MascotState = "idle" | "writing"

interface Props {
  state?: MascotState
  className?: string
}

export default function Mascot({ state = "idle", className = "" }: Props) {
  const isWriting = state === "writing"

  return (
    <div
      className={`mascot-container ${isWriting ? "mascot-writing" : "mascot-idle"} ${className}`}
    >
      <svg
        viewBox="0 0 100 120"
        xmlns="http://www.w3.org/2000/svg"
        className="h-full w-full"
        aria-hidden="true"
      >
        {/* Clipboard board */}
        <rect
          x="12"
          y="18"
          width="62"
          height="85"
          rx="6"
          fill="#f5f0e8"
          stroke="#d4cfc4"
          strokeWidth="1.5"
        />

        {/* Clipboard clip */}
        <rect x="30" y="12" width="26" height="14" rx="4" fill="#bbb" />
        <rect x="34" y="10" width="18" height="8" rx="3" fill="#ccc" />

        {/* Paper */}
        <rect
          x="18"
          y="30"
          width="50"
          height="67"
          rx="2"
          fill="white"
          stroke="#e8e4dc"
          strokeWidth="1"
        />

        {/* Written lines (appear during/after writing) */}
        <g className="notepad-lines">
          <line
            x1="24"
            y1="42"
            x2="56"
            y2="42"
            stroke="#7AF2A8"
            strokeWidth="2"
            strokeLinecap="round"
            opacity="0.7"
          />
          <line
            x1="24"
            y1="50"
            x2="50"
            y2="50"
            stroke="#7AF2A8"
            strokeWidth="2"
            strokeLinecap="round"
            opacity="0.5"
          />
          <line
            x1="24"
            y1="58"
            x2="53"
            y2="58"
            stroke="#7AF2A8"
            strokeWidth="2"
            strokeLinecap="round"
            opacity="0.4"
          />
        </g>

        {/* Blank ruled lines */}
        <line x1="24" y1="66" x2="62" y2="66" stroke="#eee" strokeWidth="1" />
        <line x1="24" y1="74" x2="62" y2="74" stroke="#eee" strokeWidth="1" />
        <line x1="24" y1="82" x2="62" y2="82" stroke="#eee" strokeWidth="1" />
        <line x1="24" y1="90" x2="62" y2="90" stroke="#eee" strokeWidth="1" />

        {/* Checkmark on first line */}
        <path
          d="M26 40 L30 44 L38 36"
          fill="none"
          stroke="#45c778"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="notepad-check"
        />

        {/* Pencil — laid diagonally across the notepad */}
        <g className="notepad-pencil" transform="rotate(50 38 68)">
          {/* Eraser */}
          <rect x="35" y="34" width="6" height="4" rx="1.5" fill="#F48FB1" />
          {/* Body */}
          <rect x="35" y="38" width="6" height="28" fill="#FFD54F" />
          {/* Band */}
          <rect x="35" y="61" width="6" height="4" fill="#E8B830" />
          {/* Wood tip */}
          <polygon points="35,65 41,65 38,73" fill="#F5E6D0" />
          {/* Lead tip */}
          <polygon points="36.5,71 39.5,71 38,73" fill="#555" />
        </g>
      </svg>
    </div>
  )
}
